module.exports = __webpack_public_path__ + "static/media/plan-1-min.f0c7aa35.png";